import type { PosTypeDto } from "../../types/PosTypeDto";
import type { PosTypeEntity } from "../../types/PosTypeEntity";

export const PosTypeEntityToDto = ({ ...rest }: Readonly<PosTypeEntity>): PosTypeDto => {
    return { ...rest };
};
